const ReportSections = {
    INTELLECTUAL_CAPABILITY: 'intellectualCapability',
    COMPETENCY_PROFILE: 'competencyProfile',
    ENQUIRY: 'enquiry',
    ABILITY_TO_CHANGE: 'abilityToChange',
    SELECTION_ADVICE: 'selectionAdvice',
    STRONG_POINTS: 'strongPoints',
    POINTS_OF_ATTENTION: 'pointsOfAttention',
    DEVELOPMENT_ADVICE: 'developmentAdvice',
    PERSONALITY: 'personality',
    WORKING_STYLES: 'workingStyles',
    RESEARCH_QUESTION: 'researchQuestion',
    INFLUENCING_STYLES: 'influencingStyles',
    MOTIVES: 'motives',
    ABOUT_REPORT: 'aboutThisReport',
    TEAM_ROLES: 'teamRoles',
    RISK_INDICATION: 'riskIndication',
    PERSONALITY_BUILDING_DOCKS: 'personalityBuildingDocks'
};

export default ReportSections;
